module.exports = __webpack_public_path__ + "img/dropdownup.b519b895.svg";